module.exports = __webpack_public_path__ + "static/solution03-icon-c97a408545540b28d7b8d2892425e7ec.png";